export default __webpack_public_path__ + "static/meta-image-c28f21d096f5a748161155fafefd3343.jpg";